module.exports = __webpack_public_path__ + "static/media/yellow_circle.39652d56.png";